import React, { useEffect, useState } from 'react'
import DynamicForm from '../../../customformComponent/customForm/DynamicForm';
import { useLocation, useNavigate } from 'react-router-dom';
import backicon from "../../../../Assets/icons/backIcon.svg";
import ROUTES_NAVIGATION from '../../../../routes/routes';

import axiosInstance from '../../../services/api/API';
import VehicleList from './VehicleList';
import Loader from '../../../customComponents/CustomLoader';




const AddVehicleDetails = ({isVehicleDetailsSubmitted,setisVehicleDetailsSubmitted,isMainFormSubmitted={isMainFormSubmitted},
  setIsMainFormSubmitted={setIsMainFormSubmitted} ,setisSparePartDetailsSubmitted,logisticID,LOGISTICID,BUSINESSPARTNERID}) => {
    const [validationErrors,setValidationErrors] = useState({})
    const [formData, setFormData] = useState({});
    const [variantOptions, setVariantOptions] = useState([]);
    const [productOptions, setProductOptions] = useState([]);
    const [iseditmode, setisEditMode] = useState(false)
    const [loading, setLoading] = useState(true);
    const token = localStorage.getItem("authToken");
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [tableData, setTableData] = useState([]);
    //const logistic_id = localStorage.getItem('logistic_id');
    const location=useLocation();
    const editlogisticid=location?.state?.data?.logistic_id
    const editBusinessPartnerID= location?.state?.data?.business_partner_id
  console.log("BUSINESSPARTNERID",editBusinessPartnerID);
  
    const logistic_stock_id = tableData[0]?.logistic_stock_id

  useEffect(() => {
    fetchLogisticData();
  }, []);
  
  const fetchLogisticData = async (page=0 , pageSize=10 ) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post(
        '/logisticsstock/list',
        {
          logistic_id:logisticID ||LOGISTICID,
          stock_type: "V",  
         orderBy:"logistic_id desc",
         page,
      pageSize,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        'Sr No.': index + 1,
      }));
  
      const totalRecordsData = response?.data?.data?.totalRecords
      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);
  
      setTableData(formattedData);
     // toastSuccess("Product Data fetched successfully!");
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error('Error fetching vendor list:', error);
    }
    finally{
      setLoading(false)
    }
  };

  const handleFormSubmit = async (data) => {
    console.log("vehicledata>>>",data);

    
   

    const errors = {};
    let isValid = true;
     CustomerInputs.forEach((field) => {
      console.log("field>>",field);
      if (field.required && !formData[field.name]) {

        errors[field.name] = "This field is required";
        isValid = false;
      } else if ( field.required && field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      console.log("validationErrors",validationErrors);
      return;
    }

    setLoading(true);

  try {

    const token = localStorage.getItem("authToken");
    if(iseditmode){
     
    const   payload ={
        stock_type:"V"||null,
        business_partner_id:BUSINESSPARTNERID ?BUSINESSPARTNERID  :editBusinessPartnerID,
        logistic_id: editlogisticid || logisticID ||LOGISTICID,
        product_id:data?.productname || null,
        variant_id:data?.variant || null,
        vehicle_id:1||null,
        selling_price:data?.selling_price,
        purchase_price:data?.purchaseprice,
      }
      const response = await axiosInstance.patch(`/logisticsstock/update/${logistic_stock_id}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        console.log('Vehicle updated successfully');
        setisEditMode(false); // Reset edit mode
        fetchLogisticData()
            } else {
        console.error('Failed to update vehicle');
      }
    

    } 
    else{
      const response = await axiosInstance.post(`/logisticsstock/create`, {
        stock_type:"V"||null,
        business_partner_id:BUSINESSPARTNERID ?BUSINESSPARTNERID: editBusinessPartnerID,
        logistic_id:editlogisticid || logisticID ||LOGISTICID ,
        selling_price:data?.selling_price,
        purchase_price:data?.purchaseprice,
        product_id:data?.productname || null,
        variant_id:data?.variant || null,
        vehicle_id:1||null,
         
        }, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        
    }
  } catch (error) {
    console.error("Error submitting form:", error);
  }
  finally{
    setLoading(false)
  }
  setFormData({})
  fetchLogisticData()
  };

 
    const fetchProductOptions = async() => {
      try {
      const productResponse = await axiosInstance.post('/product/ddlproduct', { business_partner_id: BUSINESSPARTNERID || editBusinessPartnerID }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const productOptions = productResponse.data.data.data?.map(product => ({
        label:product.NAME,
        value: product.ID,
      }));
      setProductOptions(productOptions);
    } catch (error) {
      console.log(error);
      
      
    }
  }
    useEffect(()=>{
      fetchProductOptions();  
    },[])
    useEffect(() => {


      if (formData.productname) {
        console.log("formData",formData);
        const fetchVariantOptions = async () => {
          try {
            const token = localStorage.getItem("authToken");
            const response = await axiosInstance.post('/variant/ddlvariant', {
              business_partner_id: BUSINESSPARTNERID,
              product_id: formData.productname
            }, {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            });
            const variantOptions = response.data.data.data?.map(variant => ({
              label:variant.NAME,
              value: variant.ID,
            }));
            

            setVariantOptions(variantOptions);
          } catch (error) {
            console.error("Error fetching variant options:", error);
          }
        };

        fetchVariantOptions();
      }
    }, [formData.productname]);

    

    useEffect(() => {
      if (formData.variant) {
        const fetchVariantBasedDetails = async () => {
          try {
            const token = localStorage.getItem("authToken");
            const response = await axiosInstance.post('/variant/ddlvariantbasedetails', {
              //business_partner_id: 1,
              variant_id: formData.variant
            }, {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            });

            const variantwisedata = response?.data?.data?.data[0]
            console.log("variantwisedata",variantwisedata);

            setFormData({
              ...formData,
              
              fueltype:variantwisedata?.fuel_type_name,
              subproduct:variantwisedata?.subproduct_name,
              make:variantwisedata?.make_name,
              model:variantwisedata?.model_name,
              exshowroomprice:variantwisedata?.exshowroom_price,
              color:variantwisedata?.color_name,
              price:variantwisedata?.exshowroom_price
              
            });
            // const variantOptions = response.data.data.data?.map(variant => ({
            //   label:variant.NAME,
            //   value: variant.ID,
            // }));
            

            // setVariantOptions(variantOptions);
          } catch (error) {
            console.error("Error fetching variant options:", error);
          }
        };

        fetchVariantBasedDetails();
      }
    }, [formData?.variant]);
  const CustomerInputs = [
    // {
    //   name: "manufacture_id",
    //   label: "Manufacture ID.",
    //   type: "number",
    //   required: false,
    //   gridClass: "col-lg-4",
    // },
    {
      name: "productname",
      label: "Product",
      type: "dropdown",
      options:productOptions,
      required: true,
      gridClass: "col-lg-4",
      validation:{required:true}
    },
    {
      name: "variant",
      label: "Variant",
      type: "dropdown",
      options:variantOptions,
      required: true,
      gridClass: "col-lg-4",
      validation:{required:true}
    },
    {
      name: "subproduct",
      label: "Sub Product",
      type: "text",
      disabled:true,
      //required: true,
      placeholder:"Sub Product",
      gridClass: "col-lg-4",
    },
    {
      name: "make",
      label: "Make",
      type: "text",
      disabled:true,
      //required: true,
      placeholder:"Make",
      gridClass: "col-lg-4",
    },
    {
      name: "model",
      label: "Model",
      type: "text",
      //required: true,
      disabled:true,
      placeholder:"Model",
      gridClass: "col-lg-4",
    },
    {
        name: "fueltype",
        label: "Fuel Type",
        type: "text",
        disabled:true,
        //required: true,
        placeholder:"Fuel Type",
        gridClass: "col-lg-4",
      },

    {
      name: "color",
      label: "Color",
      type: "text",
      //required: true,
      placeholder:"Color",
      disabled:true,
      gridClass: "col-lg-4",
    },
   
   
    {
      name: "purchaseprice",
      label: "Purchase Price",
      type: "text",
      placeholder:"Enter Purchase Price",
      validation: { 
        required: true,
        pattern: /^[0-9]+(\.[0-9]{1,2})?$/, 
        message: "Please enter a valid purchase price with up to 2 decimal points*"
      },
      
     // disabled:true,
      gridClass: "col-lg-4",
    },
    {
      name: "selling_price",
      label: "Selling Price",
      placeholder:"Enter Purchase Price",
      type: "text",
      validation: { required: true,  pattern: /^[0-9]+(\.[0-9]{1,2})?$/, message: "Please Enter Valid Selling Price*"},
     // disabled:true,
      gridClass: "col-lg-4",
    },
   
   
  ];
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchLogisticData(newPage); 
  };

  return (
    <>
     
        <div className="d-flex flex-row justify-content-between" style={{marginBottom:"25px"}}>
            <div>
        <span className="cust-det-title mt-2 mb-2">
          Add Vehicle Details
        </span>
            </div> 
        </div>
        <div>
    {loading ? ( 
      <Loader />
    ) : (
      <div>
        <DynamicForm
        formConfig={CustomerInputs}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleFormSubmit}
        validationErrors={validationErrors}
        setValidationErrors={setValidationErrors}
          // formConfig={CustomerInputs}
          // formData={formData}
          // setFormData={setFormData}
          // onSubmit={handleFormSubmit}
        />
   
    

      <div className="btncontainer mt-3 gap-2">
        {/* <button style={{backgroundColor:"#fff", padding:"10px 20px" , borderRadius:"10px", color:"#7BD755", border:"1px solid #7BD755"}}>
            Back
        </button> */}
        <button
    
        onClick={() => handleFormSubmit(formData)}
          className="submit-btn"
        >
         {iseditmode?"Update":"Submit"} 
        </button>
      </div>
      <VehicleList tableData={tableData} formData={formData} onPageChange={handlePageChange} currentPage={currentPage}  totalPages={totalPages}
        setFormData={setFormData} setisEditMode={setisEditMode} totalRecords={totalRecords} />

{/* Table */}

</div>
    )}
    </div>
    </>
  )
}

export default AddVehicleDetails